<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>I am eternally grateful to all the people who have encouraged me in one way or the next; literally, too numerous to mention, but you know yourselves so take a bow. To all the people who have inspired me; keep on shining, sometimes the rest of us need your light to find our way. Thank you, Marva Waugh, John “Toby” Cadham, Saundra Fisher, Gail Bogle, Nadia Nembhard-Hunt, Courace Fisher and Barbara Stewart-Edwards for your constant and consistent encouragement you are appreciated.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?1adf07d4